import { render, staticRenderFns } from "./CancellationRefundPreview.vue?vue&type=template&id=363db352&scoped=true&"
import script from "./CancellationRefundPreview.vue?vue&type=script&lang=js&"
export * from "./CancellationRefundPreview.vue?vue&type=script&lang=js&"
import style0 from "./CancellationRefundPreview.vue?vue&type=style&index=0&id=363db352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363db352",
  null
  
)

export default component.exports